import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  border-radius: 5px;
  padding: 10px;
  overflow: auto;
  color: white;
`;

export const Lines = styled.div`
  height: 0;
  overflow: auto;
`;
